import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministrativeRoutingModule } from './administrative-routing.module';
import { ManageContractComponent } from './manage-contract/manage-contract.component';
import { AdministrativeDashboardComponent } from './dashboard/dashboard.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CoreModule } from 'src/app/core/core.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ContractCreateOrUpdateComponent } from './manage-contract/contract-create-or-update/contract-create-or-update.component';
import { ManageCompanyComponent } from './manage-company/manage-company.component';
import { ViewCompanyComponent } from './manage-company/view-company/view-company.component';
import { AppraisalListComponent } from './manage-appraisal/appraisal-list/appraisal-list.component';
import { AppraisalCreateOrUpdateComponent } from './manage-appraisal/appraisal-create-or-update/appraisal-create-or-update.component';
import { ContractViewModelComponent } from './manage-contract/contract-view-model/contract-view-model.component';
import { CreateOrUpdateCompanyComponent } from './manage-company/create-or-update-company/create-or-update-company.component';
import { AppaisalMeasurementsUpdateComponent }
  from './manage-appraisal/appaisal-measurements-update/appaisal-measurements-update.component';
import { ManageModuleComponent } from './manage-module/manage-module.component';
import { UsersComponent } from './manage-module/users/users.component';
import { PermissionsComponent } from './manage-module/permissions/permissions.component';
import { UserSelectModalComponent } from './manage-module/user-select-modal/user-select-modal.component';
import { UserDetailModalComponent } from './manage-module/user-detail-modal/user-detail-modal.component';
import { EditAdminPermissionModalComponent } from './manage-module/edit-admin-permission-modal/edit-admin-permission-modal.component';
import { ExportModalComponent } from './manage-appraisal/export-modal/export-modal.component';

@NgModule({
  declarations: [
    ManageContractComponent,
    AppraisalListComponent,
    AdministrativeDashboardComponent,
    ContractCreateOrUpdateComponent,
    ManageCompanyComponent,
    ViewCompanyComponent,
    AppraisalCreateOrUpdateComponent,
    ContractViewModelComponent,
    CreateOrUpdateCompanyComponent,
    AppaisalMeasurementsUpdateComponent,
    ManageModuleComponent,
    UsersComponent,
    PermissionsComponent,
    UserSelectModalComponent,
    UserDetailModalComponent,
    EditAdminPermissionModalComponent,
    ExportModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CoreModule,
    MatCheckboxModule,
    MatRadioModule,
    FormsModule,
    DragDropModule,
    ReactiveFormsModule,
    AdministrativeRoutingModule,
  ],
  entryComponents: [
    UserSelectModalComponent
  ]
})
export class AdministrativeModule { }
